// 1、引入axios库
import axios from "axios"

// 2、创建axios实例
const service = axios.create({
    baseURL: '',  // api的base_url
    timeout: 5000  // 请求超时时间
})

// 3、请求拦截器
service.interceptors.request.use(
    config => {

        // 获取token，如果有token，就放入http的请求头里面
        // let token = window.sessionStorage.getItem("token")
        // if(token) {
        //     config.headers = {
        //         'token': token
        //     }
        // }
        
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 4、响应拦截器
service.interceptors.response.use(
    response => {
        // 定时刷新token
        return response
    },
    error => {
        return Promise.reject(error)
    }
)

export default service